<template>
  <v-card class="elevation-12 mb-6">
    <v-card-title class="px-9 pt-7">
      {{ title }}
    </v-card-title>

    <v-card-text class="px-9">
      <ValidationObserver ref="userForm" v-slot="{ invalid, passes }">
        <v-form rel="userForm" @submit.prevent="passes(save)">
          <v-row>
            <v-col cols="8">
              <v-row>
                <v-col cols="6" class="py-0">
                  <VTextFieldWithValidation
                    rules="required"
                    v-model="value.firstName"
                    outlined
                    dense
                    label="Jméno"
                    data-cy="firstName"
                  />
                </v-col>

                <v-col cols="6" class="py-0">
                  <VTextFieldWithValidation
                    rules="required"
                    v-model="value.lastName"
                    outlined
                    dense
                    label="Příjmení"
                    data-cy="lastName"
                  />
                </v-col>

                <v-col cols="6" class="py-0">
                  <VTextFieldWithValidation
                    rules="required|email"
                    v-model="value.email"
                    outlined
                    dense
                    label="E-mail"
                    data-cy="email"
                  />
                </v-col>

                <v-col cols="6" class="py-0">
                  <VTextFieldWithValidation
                    rules="required|phone"
                    v-model="value.phone"
                    outlined
                    dense
                    label="Telefon (ve formátu +420222444666)"
                    data-cy="phone"
                  />
                </v-col>

                <slot></slot>

                <v-col cols="12" class="py-0">
                  <VFileInputWithValidation
                    v-model="value.certificateFile"
                    :rules="{
                      required: false,
                      ext: ['der', 'cer', 'pem', 'p12', 'crt'],
                    }"
                    prepend-icon=""
                    append-icon="$file"
                    @click:append="
                      $event.target.offsetParent
                      .querySelector(`[class='v-file-input__text']`).click()
                    "
                    :clearable="false"
                    outlined
                    dense
                    :label="certLabel"
                    accept=".der, .cer, .crt, .pem, .p12"
                    @change="fileUpload($event)"
                    data-cy="cert"
                  />
                </v-col>

                <v-col class="text-right">
                  <v-btn
                    type="submit"
                    color="primary"
                    height="40px"
                    min-width="125px"
                    depressed
                    :loading="loading"
                  >
                    Uložit
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </ValidationObserver>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'UserForm',
  props: {
    value: {
      type: Object,
    },
    title: {
      type: String,
      default: '',
    },
    userAdd: {
      type: Boolean,
      default: false,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  computed: {
    certLabel() {
      let label = '';
      const certExtensions = '(soubor .der, .cer, .crt, .pem, .p12)';
      if (this.$route.path.includes('edit')) {
        label = `Změna certifikátu ${certExtensions}`;
      } else {
        label = `Certifikát ${certExtensions}`;
      }
      return label;
    },
  },
  methods: {
    save() {
      const form = this.value;
      form.phone = form.phone.replace(/[\n# $&:\n\t]/g, '');
      this.$emit('save', form);
    },
    fileUpload(event) {
      this.$emit('certificateChanged', event);
    },
  },
};
</script>
